/** Free-tier Worker subrequest budget is ~50/invocation — keep scrape chunks small. */
export const SCRAPE_DAYS_PER_INVOKE = 3;

export function chunkDateKeys(dateKeys: string[], size = SCRAPE_DAYS_PER_INVOKE): string[][] {
  const chunks: string[][] = [];
  for (let i = 0; i < dateKeys.length; i += size) {
    chunks.push(dateKeys.slice(i, i + size));
  }
  return chunks;
}

export function chunkDateRange(
  dateKeyStart: string,
  dateKeyEnd: string,
  size = SCRAPE_DAYS_PER_INVOKE,
): Array<{ dateKeyStart: string; dateKeyEnd: string }> {
  // Local YYYY-MM-DD walk (mirrors eachDateKey without importing Worker modules in the SPA).
  if (dateKeyStart > dateKeyEnd) throw new Error("dateKeyStart must be <= dateKeyEnd.");
  const keys: string[] = [];
  let cur = dateKeyStart;
  while (cur <= dateKeyEnd) {
    keys.push(cur);
    const [y, m, d] = cur.split("-").map(Number);
    const next = new Date(Date.UTC(y!, m! - 1, d! + 1));
    const pad = (n: number) => String(n).padStart(2, "0");
    cur = `${next.getUTCFullYear()}-${pad(next.getUTCMonth() + 1)}-${pad(next.getUTCDate())}`;
    if (keys.length > 366) throw new Error("Date range too large.");
  }
  return chunkDateKeys(keys, size).map((chunk) => ({
    dateKeyStart: chunk[0]!,
    dateKeyEnd: chunk[chunk.length - 1]!,
  }));
}
